<div class="main-content-container">
  <div class="layout_tab_horizontal">
    <ul class="base-tab tabWithoutButtons">
      <li class="nav-item">
        <a class="nav-link" id="nav-consultation-tab" [ngClass]="activeTab == 'pending'? 'active': ''"
        data-toggle="tab" (click)="hasActiveTab('pending')">Pending</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="activeTab == 'completed'? 'active': ''" id="nav-diagnostic-tab"
        data-toggle="tab" (click)="hasActiveTab('completed')">Completed</a>
      </li>
    </ul>

    <div [ngClass]="utilService.isMobile()?'_wf-sbts-greybg':'_wf-dts-bordershadow'">
      @if (activeTab == 'pending') {
        <div class="tab-pane mb-5" [ngClass]="activeTab == 'pending'? 'active': ''"
          id="nav-consultation" role="tabpanel" aria-labelledby="nav-consultation-tab">
          <div class="text-capitalize"
            [ngClass]="utilService.isMobile()?'_wf-sdts-allpointstop':'_wf-dts-navpoints'">
            <div [ngClass]="utilService.isMobile()?'_wf-dts-mob':'_wf-dts-rgtpoints'">
              <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
                <div class="text-block-230"><i class="fa fa-circle pending"></i>
              </div>
              <div class="text-block-231">Pending</div>
            </div>
            <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
              <i class="fa fa-circle completed"></i>
              <div class="text-block-231">Completed</div>
            </div>
            <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
              <i class="fa fa-circle cancelled"></i>
              <div class="text-block-231">Cancelled</div>
            </div>
            <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
              <i class="fa fa-circle NA"></i>
              <div class="text-block-231">NA</div>
            </div>
          </div>
        </div>
        @if (gridData && _currentData.finalKeys) {
          <dhs-data-grid [data]="gridData"
            [fields]="_currentData.finalKeys" [config]="dataGridConfig" (onLimitChange)="onLimit($event)"
            (onPageChanges)="onPageChanged($event)" (editEllipseClick)="redirect($event)" [rowClick]="_currentData.resouceDef.list.rowClick"
            (onFilterChange)="onFilter($event)" (bindGrid)="bindDataToGrid($event)" [filterFieldGroup]="_currentData" (onSortChanges)="sortChanges($event);" (configValues)="getConfigValues($event)">
          </dhs-data-grid>
        }
      </div>
    }

    @if (activeTab == 'completed') {
      <div class="tab-pane mb-5"
        [ngClass]="activeTab == 'completed'? 'active': ''" id="nav-diagnostic" role="tabpanel"
        aria-labelledby="nav-diagnostic-tab">
        <div class="text-capitalize"
          [ngClass]="utilService.isMobile()?'_wf-sdts-allpointstop':'_wf-dts-navpoints'">
          <div [ngClass]="utilService.isMobile()?'_wf-dts-mob':'_wf-dts-rgtpoints'">
            <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
              <i class="fa fa-circle pending"></i>
              <div class="text-block-231">Pending</div>
            </div>
            <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
              <i class="fa fa-circle completed"></i>
              <div class="text-block-231">Completed</div>
            </div>
            <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
              <i class="fa fa-circle cancelled"></i>
              <div class="text-block-231">Cancelled</div>
            </div>
            <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
              <i class="fa fa-circle NA"></i>
              <div class="text-block-231">NA</div>
            </div>
          </div>
        </div>
        @if (gridData && _currentData.finalKeys) {
          <dhs-data-grid [data]="gridData"
            [fields]="_currentData.finalKeys" [config]="dataGridConfig" (onLimitChange)="onLimit($event)"
            (onPageChanges)="onPageChanged($event)" (editEllipseClick)="redirect($event)"
            [rowClick]="_currentData.resouceDef.list.rowClick"
            (onFilterChange)="onFilter($event)" (bindGrid)="bindDataToGrid($event)" [filterFieldGroup]="_currentData" (onSortChanges)="sortChanges($event);" (configValues)="getConfigValues($event)">
          </dhs-data-grid>
        }
      </div>
    }
  </div>
</div>
</div>